import React from 'react';
import { connect } from 'react-redux';
import View from './ExplanationsView';
import MobileView from '../../MobileFinancialPlan/MobileExplanations/MobileExplanationsView';
import MobileExplanationsWithMenuView from '../../MobileFinancialPlan/MobileExplanations/MobileExplanationsWithMenuView';
import { useAreBothPartiesCurrentlyReceiving } from '../../FinancialPlanOPL/Goals/goals/Retirement/tabs/SocialSecurity/useAreBothPartiesCurrentlyReceiving';
import { updateGoalViewState } from '../FinancialPlanActions';
import { goalId as selectedGoalIdSelector } from '../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import { SOCIAL_SECURITY } from '../Retirement/RetirementConstants';
import { OVERVIEW } from './ExplanationsConst';
import {
  recommendationTitleOrDefaultSelector,
  selectedSectionOrDefaultSelector,
  sectionsOrDefaultSelector,
  noTabsSelector,
  recommendationMessageOrDefaultSelector,
} from './ExplanationsSelector';

const mapStateToProps = (state, ownProps) => ({
  goalId: selectedGoalIdSelector(state, ownProps),
  selectedSection: ownProps.currentTab || selectedSectionOrDefaultSelector(state, ownProps),
  sections: sectionsOrDefaultSelector(state, ownProps),
  recommendationTitle: recommendationTitleOrDefaultSelector(state, ownProps),
  noTabs: noTabsSelector(state, ownProps),
  recommendationMessage: recommendationMessageOrDefaultSelector(state, ownProps),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  setSelectedSection: (goalId, selectedSection, clientId) => () => {
    if (ownProps.setCurrentTab) {
      ownProps.setCurrentTab(selectedSection);
    } else {
      dispatch(
        updateGoalViewState(goalId, clientId, {
          selectedSection,
        }),
      );
    }
  },
});

const withHiddenSocialSecurityTab = Component => props => {
  const hideSocialSecurity = useAreBothPartiesCurrentlyReceiving();
  const sections = hideSocialSecurity
    ? props.sections.filter(section => section !== SOCIAL_SECURITY)
    : props.sections;
  const selectedSection =
    hideSocialSecurity && props.selectedSection === SOCIAL_SECURITY
      ? OVERVIEW
      : props.selectedSection;

  return (
    <Component
      {...props}
      sections={sections}
      selectedSection={selectedSection}
      noTabs={sections.length < 2}
    />
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(withHiddenSocialSecurityTab(View));

export const MobileExplanations = connect(mapStateToProps, mapDispatchToProps)(MobileView);

export const MobileExplanationsWithMenu = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withHiddenSocialSecurityTab(MobileExplanationsWithMenuView));
